import React, { useEffect } from "react";
import { Navigate, Route, Routes, useLocation } from "react-router-dom";
import HomePage from "../Components/homepage/HomePage";
import ContactPage from "../Components/contactpage/ContactPage";
import IndustriesServePage from "../Components/industries-servepage/IndustriesServePage";
import AboutUsPage from "../Components/aboutuspage/AboutUsPage";
import ServicesPage from "../Components/servicespage/ServicesPage";
import Investment from "../Components/investment-opportunitiespage/InvestmentOpportunities";
import ResearchPage from "../Components/research-devpage/ResearchPage";
import EventsPage from "../Components/events_conferencepage/EventsAndConference";
import Founder from "../Components/founderMessage/founderMessage";
import PPPage from "../Components/ppppage/PPPage";

const Routing = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return (
    <Routes>
      <Route path="/" element={<Navigate to="home" />} />
      <Route path="/home" element={<HomePage />} />
      <Route path="/contact" element={<ContactPage />} />
      <Route path="/industries-we-serve" element={<IndustriesServePage />} />
      <Route path="/about-us" element={<AboutUsPage />} />
      <Route path="/services" element={<ServicesPage />} />
      <Route path="/invesment-opportunities" element={<Investment />} />
      <Route path="/research-development" element={<ResearchPage />} />
      <Route path="/events-conference" element={<EventsPage />} />
      <Route path="/founder-message" element={<Founder />} />
      <Route path="/ppp-partnerships" element={<PPPage />} />
    </Routes>
  );
};

export default Routing;
